function CertificationFormController($scope, $timeout, $element, dataService) {
    $scope.model = {
        firstName: null,
        lastName: null,
        company: null,
        title: null,
        email: null,
        email2: null,
        whereHearAbout: null,
        whereHearAboutSource: null
    };
    // console.log($scope.model);

    var resetVal = function () {
        $scope.saving = {
            active: false,
            success: false,
            denied: false,
            error: false
        };
        $scope.val = {
            firstName: {req: false},
            lastName: {req: false},
            companyName: {req: false},
            title: {req: false},
            email: {req: false, badFormat: false},
            email2: {match: false},
            hear: {req:false},
            captcha: {req:false}
        };
    };
    resetVal();

    var scrollToError = function () {
        $timeout(function () {
            var $elm = angular.element('.ui-has-error');
            if (!$elm || $elm.length <= 0) return;
            var o = $elm.offset();
            angular.element('html,body').animate({scrollTop: o.top - 90}, 'fast');
        }, 0);
    };

    this.$postLink = function() {
        setTimeout(function() {
            var $after = angular.element(document.getElementById('after-content'));
            $after.append($element);
        }, 100);
    };

    $scope.submit = function (e) {
        e.preventDefault();
        resetVal();
        var isValid = true;

        //console.log($scope.model);

        if (!$scope.model.email) {
            $scope.val.email.req = true;
            isValid = false;
        }
        else {
            if (!dataService.validEmail($scope.model.email)) {
                $scope.val.email.badFormat = true;
                isValid = false;
            }

            if (!$scope.model.email2 || $scope.model.email2.toLowerCase() !== $scope.model.email.toLowerCase()) {
                $scope.val.email2.match = true;
                isValid = false;
            }
        }


        if (!$scope.model.firstName) {
            $scope.val.firstName.req = true;
            isValid = false;
        }

        if (!$scope.model.lastName) {
            $scope.val.lastName.req = true;
            isValid = false;
        }

        /*if (!$scope.model.companyName) {
            $scope.val.companyName.req = true;
            isValid = false;
        }*/
        /*if (!$scope.model.title) {
            $scope.val.title.req = true;
            isValid = false;
        }*/

        /*if (!$scope.model.whereHearAbout) {
            $scope.val.hear.req = true;
            isValid = false;
        }*/

        $scope.model.captcha = grecaptcha.getResponse();
        if (!$scope.model.captcha) {
            $scope.val.captcha.req = true;
            isValid = false;
        }

        if (!isValid) {
            scrollToError();
            return;
        }

        $scope.saving.active = true;
        dataService.certification($scope.model)
            .then(function () {
                $scope.saving.success = true;
                $scope.saving.active = false;
            })
            .catch(function () {
                $scope.saving.error = true;
                $scope.saving.active = false;
            });
    };
}

function CertificationIndexController($scope, $sce, $q, $location, dataService) {
    $scope.email = {
        get: true,
        value: null,
        val: null
    }
    $scope.certification = null;
    $scope.items = [];
    $scope.openItem = null;
    $scope.postItem = null;
    $scope.postListingItem = null;
    $scope.progress = {
        total: 0,
        completed: 0,
        percent: '0%'
    };
    $scope.posting = {
        active: false,
        status: null
    }
    $scope.score = null;

    var findItem = function(slug) {
        var _findItem = function(items) {
            for (var i=0; i<items.length; i++) {
                if (items[i].slug === slug) return items[i];
                if (items[i].children) {
                    var item = _findItem(items[i].children);
                    if (item) return item;
                }
            }
            return null;
        };
        return _findItem($scope.items);
    };

    var toAutoIndex = function(numbering, idx) {
        var toAlphaIndex = function(idx, lower) {
            var ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[idx];
            return lower ? ch.toLowerCase() : ch;
        }
        if (numbering === 'alphaLower') return toAlphaIndex(idx, true);
        if (numbering === 'alphaUpper') return toAlphaIndex(idx, false);
        return (idx + 1).toString();
    }

    var load = function() {
        var results = JSON.parse($scope.certification.results || '{}');

        var certificationMap = JSON.parse($('script#certificationMap').text());
        // console.log('certificationMap', certificationMap);

        // Load all the posts.
        loadAllPosts(certificationMap)
            .then(function(posts) {
                var mapItems = function(theItems, addTo, parent) {
                    _.each(theItems, function(item) {
                        var thisItem = {
                            slug: item.slug, testSegment: item.testSegment,
                            parent: parent,
                            next: null, previous: null,
                            isReview: item.slug ===  'certification-completion',
                            isResults: item.slug === 'certification-results'
                        };
                        addTo.push(thisItem);

                        if (thisItem.testSegment) {
                            thisItem.testSegment.progress = {
                                total: thisItem.testSegment.questions.length,
                                completed: 0,
                                percent: '0%'
                            }
                            $scope.progress.total += thisItem.testSegment.questions.length;
                        }

                        if (item.label) {
                            thisItem.label = item.label;
                            if (item.children && item.children.length > 0) {
                                thisItem.children = [];
                                mapItems(item.children, thisItem.children, thisItem, thisItem);
                            }
                        }
                        else {
                            var thePost = _.find(posts, function(post) { return post.slug === item.slug; });
                            if (!thePost) return;

                            thisItem.label = thePost.title;
                            thePost.html = $sce.trustAsHtml(thePost.html);
                            thisItem.post = thePost;

                            if (item.children && item.children.length > 0) {
                                thisItem.children = [];
                                mapItems(item.children, thisItem.children, thisItem, thisItem);
                            }
                        }
                    });
                }
                var items = [];
                mapItems(certificationMap, items, null, null);

                //console.log(items);


                var flatten = [];
                var flattenItems = function(items) {
                    _.each(items, function(item) {
                        flatten.push(item);
                        if (item.children) flattenItems(item.children);
                    });
                }
                flattenItems(items);
                var prev = null;
                _.each(flatten, function(item) {
                    if (item.isResults) return;
                    if (item.testSegment) {
                        _.each(item.testSegment.questions, function(q, qIdx) {
                            var qResult = results[q.id];

                            q.answerChecked = qResult && qResult.checked;
                            _.each(q.answers, function(a, aIdx) {

                                if (q.answerNumbering) {
                                    var answerEx = [];
                                    answerEx.push('<div class="answer-idx">' + toAutoIndex(q.answerNumbering, aIdx) + ')</div>');
                                    answerEx.push('<div class="answer-val">');
                                    if (a.repeatOptions) {
                                        var indexes = a.repeatOptions.split(',');
                                        if (indexes.length === 1)
                                            answerEx.push(toAutoIndex(q.answerNumbering, indexes[0] - 1).toUpperCase());
                                        else if (indexes.length === 2) {
                                            answerEx.push(toAutoIndex(q.answerNumbering, indexes[0] - 1).toUpperCase());
                                            answerEx.push(' and ');
                                            answerEx.push(toAutoIndex(q.answerNumbering, indexes[1] - 1).toUpperCase());
                                        } else {
                                            for (var i = 0; i < indexes.length; i++) {
                                                if (i === indexes.length - 1) answerEx.push(' and ');
                                                else if (i > 0) answerEx.push(', ');
                                                answerEx.push(toAutoIndex(q.answerNumbering, indexes[i] - 1).toUpperCase());
                                            }
                                        }
                                    }
                                    else answerEx.push(a.answer.trim());
                                    answerEx.push('</div>');

                                    a.answerEx = $sce.trustAsHtml(answerEx.join(''));
                                }
                                else {
                                    a.answer = a.answer.trim();
                                    if (a.answer.indexOf('\t') >= 0) {
                                        // console.log('has tab', a.answer);
                                        var p = a.answer.split('\t');

                                        //console.log(p[0].trim(), ' - ', p[1].trim());
                                        a.answerEx = $sce.trustAsHtml('<div class="answer-idx">'+p[0].trim()+'</div><div class="answer-val">'+p[1].trim()+'</div>')
                                    }
                                    else a.answerEx = $sce.trustAsHtml(a.answer);
                                }

                                if (qResult) {
                                    if (_.find(qResult.answers, function(id) { return id === a.id }))
                                        a.selected = true;
                                }
                            });
                        })
                    }
                    if (prev) prev.next = item;
                    item.previous = prev;
                    prev = item;
                })

                // console.log(items);
                $scope.items = items;
                $scope.onAnswer();

                var p = $location.path();
                if (p) {
                    p = p.substring(1);
                    var item = findItem(p);
                    //console.log(item);
                    if (item) {
                        $scope.openItem = item.parent;
                        if (item.slug) {
                            $scope.postItem = item;
                            document.title = 'eTest | ' + $scope.postItem.post.title;
                        }
                        else {
                            $scope.postListingItem = item;
                            document.title = 'eTest | ' + item.label;
                        }
                    }
                    else {
                        $scope.openItem = $scope.items[0];
                        if ($scope.openItem.slug) $scope.postItem = $scope.openItem;
                        else $scope.postListingItem = $scope.openItem;
                        document.title = 'eTest | ' + $scope.openItem.label;
                    }
                }
                else {
                    $scope.openItem = $scope.items[0];
                    if ($scope.openItem.slug) $scope.postItem = $scope.openItem;
                    else $scope.postListingItem = $scope.openItem;
                    document.title = 'eTest | ' + $scope.openItem.label;
                }
                $scope.$apply();
            });
    }

    $scope.emailSubmit = function(e) {
        e.preventDefault();
        $scope.email.val = null;
        if (!$scope.email.value) {
            $scope.email.val = 'Please enter your email address.'
            return;
        }

        dataService.getCertification($scope.email.value)
            .then(function(result) {
                $scope.certification = result.data;
                if ($scope.certification.completedAt) {
                    $scope.email.val = 'Certification has been completed.';
                    return;
                }
                $scope.email.get = false;
                load();
            })
            .catch(function(err) {
                console.error(err);
                $scope.email.val = 'Unable to find your certification.';
            })
    }

    $scope.handleClick = function(e, item) {
        e.preventDefault();
        if (item.slug) {
            if (!item.parent) $scope.openItem = null;
            $scope.postListingItem = null;
            $scope.postItem = item;
            $location.path(item.slug, false);
            document.title = 'eTest | ' + item.post.title;
        }
        else {
            $scope.openItem = item;
            if ($scope.openItem.slug) {
                $scope.postListingItem = null;
                $scope.postItem = $scope.openItem;
                $location.path($scope.openItem.slug, false);
                document.title = 'eTest | ' + $scope.postItem.post.title;
            }
            else {
                $scope.postItem = null;
                $scope.postListingItem = $scope.openItem;
                $location.path(null, false);
                document.title = 'eTest | ' + $scope.openItem.label;
            }
        }
        var elm = document.getElementById('the-content');
        if (elm) elm.scrollTo(0, 0);
    };
    $scope.onAnswer = function() {
        var results = {};
        var totalCompleted = 0;
        var progress = function(items) {
            _.each(items, function(item) {
                if (item.testSegment) {
                    var tsCompleted = 0;
                    _.each(item.testSegment.questions, function(q) {
                        results[q.id] = {
                            checked: q.answerChecked,
                            answers: []
                        };

                        var ready = false;
                        _.each(q.answers, function(a) {
                            if (a.selected) {
                                if (!ready) {
                                    tsCompleted++;
                                    totalCompleted++;
                                    ready = true;
                                }
                                results[q.id].answers.push(a.id);
                            }
                        });
                    })
                    item.testSegment.progress.completed = tsCompleted;
                    item.testSegment.progress.percent = ((item.testSegment.progress.completed / item.testSegment.progress.total) * 100) + '%';
                }
                if (item.children) progress(item.children);
            });
        };
        progress($scope.items);
        $scope.progress.completed = totalCompleted;
        $scope.progress.percent = (($scope.progress.completed / $scope.progress.total) * 100) + '%';


        dataService.putCertification($scope.certification.id, {
            results: JSON.stringify(results),
            isComplete: $scope.progress.completed >= $scope.progress.total
        });
    };

    $scope.submit = function(e) {
        e.preventDefault();

        var flatten = [];
        var flattenItems = function(items) {
            _.each(items, function(item) {
                flatten.push(item);
                if (item.children) flattenItems(item.children);
            });
        }
        flattenItems($scope.items);

        var score = {total: 0, correct: 0, incorrect: 0};

        var model = [];
        _.each(flatten, function(item) {
            if (!item.testSegment) return;

            var iResult = {
                label: item.label,
                questions: []
            }
            model.push(iResult);

            _.each(item.testSegment.questions, function(q) {
                score.total++;
                var qResult = {
                    question: q.question,
                    isCorrect: false,
                    answers: [],
                    correctAnswers: []
                };
                iResult.questions.push(qResult);

                if (q.type === 'trueFalse') {
                    _.each(q.answers, function(a) {
                        if (a.isCorrect) qResult.isCorrect = a.selected === true;
                        if (a.selected) qResult.answers.push(a.answer);
                    });
                    if (!qResult.isCorrect) {
                        _.each(q.answers, function(a) {
                            if (a.isCorrect) qResult.correctAnswers.push(a.answer);
                        });
                    }
                }
                else if (q.type === 'singleSelect') {
                    _.each(q.answers, function(a, aIdx) {
                        var answerIndex = q.answerNumbering ? toAutoIndex(q.answerNumbering, aIdx) : null;
                        if (a.selected) {
                            if (a.isCorrect) qResult.isCorrect = true;
                            if (q.answerNumbering) {
                                if (a.repeatOptions) {
                                    var indexes = a.repeatOptions.split(',');
                                    var theAnswers = indexes.map(function(i) {
                                        return q.answers[i-1].answer;
                                    });
                                    var answerItems = [];
                                    if (indexes.length === 1)
                                        answerItems.push(toAutoIndex(q.answerNumbering, indexes[0] - 1).toUpperCase());
                                    else if (indexes.length === 2) {
                                        answerItems.push(toAutoIndex(q.answerNumbering, indexes[0] - 1).toUpperCase());
                                        answerItems.push(' and ');
                                        answerItems.push(toAutoIndex(q.answerNumbering, indexes[1] - 1).toUpperCase());
                                    } else {
                                        for (var i = 0; i < indexes.length; i++) {
                                            if (i === indexes.length - 1) answerItems.push(' and ');
                                            else if (i > 0) answerItems.push(', ');
                                            answerItems.push(toAutoIndex(q.answerNumbering, indexes[i] - 1).toUpperCase());
                                        }
                                    }
                                    qResult.answers.push(answerIndex + ') ' + answerItems.join('') + ' [' + theAnswers.join('/') + ']');
                                }
                                else qResult.answers.push(answerIndex + ') ' + a.answer);
                            }
                            else qResult.answers.push(a.answer);
                        }
                    });

                    if (!qResult.isCorrect) {
                        _.each(q.answers, function(a, aIdx) {
                            if (!a.isCorrect) return

                            var answerIndex = q.answerNumbering ? toAutoIndex(q.answerNumbering, aIdx) : null;
                            if (q.answerNumbering) {
                                if (a.repeatOptions) {
                                    var indexes = a.repeatOptions.split(',');
                                    var theAnswers = indexes.map(function(i) {
                                        return q.answers[i-1].answer;
                                    });
                                    var answerItems = [];
                                    if (indexes.length === 1)
                                        answerItems.push(toAutoIndex(q.answerNumbering, indexes[0] - 1).toUpperCase());
                                    else if (indexes.length === 2) {
                                        answerItems.push(toAutoIndex(q.answerNumbering, indexes[0] - 1).toUpperCase());
                                        answerItems.push(' and ');
                                        answerItems.push(toAutoIndex(q.answerNumbering, indexes[1] - 1).toUpperCase());
                                    } else {
                                        for (var i = 0; i < indexes.length; i++) {
                                            if (i === indexes.length - 1) answerItems.push(' and ');
                                            else if (i > 0) answerItems.push(', ');
                                            answerItems.push(toAutoIndex(q.answerNumbering, indexes[i] - 1).toUpperCase());
                                        }
                                    }
                                    qResult.correctAnswers.push(answerIndex + ') ' + answerItems.join('') + ' [' + theAnswers.join('/') + ']');
                                }
                                else qResult.correctAnswers.push(answerIndex + ') ' + a.answer);
                            }
                            else qResult.correctAnswers.push(a.answer);
                        });
                    }
                }
                else if (q.type === 'multiSelect') {
                    var needed = 0;
                    var correct = 0;
                    var incorrect = 0;
                    _.each(q.answers, function(a) {
                        if (a.isCorrect) {
                            needed++;
                            if (a.selected) correct++;
                        }
                        else {
                            if (a.selected) incorrect++;
                        }
                        if (a.selected) qResult.answers.push(a.answer);
                    });
                    qResult.isCorrect = correct === needed && incorrect <= 0;

                    if (!qResult.isCorrect) {
                        _.each(q.answers, function(a) {
                            if (a.isCorrect) qResult.correctAnswers.push(a.answer);
                        });
                    }
                }

                if (qResult.isCorrect) score.correct++;
                else score.incorrect++;
            });
        });

        score.score = Math.round(score.correct / score.total * 100);

        $scope.posting.active = true;
        dataService.postCertificationResults($scope.certification.id, {model: model, score: score})
            .then(function() {
                $scope.posting.active = false;
                $scope.posting.status = 'complete';
                //debugger;

                var item = _.find($scope.items, function(item) { return item.isResults });
                if (!item) return;

                $scope.score = score;
                if (!item.parent) $scope.openItem = null;
                $scope.postListingItem = null;
                $scope.postItem = item;
                $location.path(item.slug, false);
                document.title = 'eTest | ' + item.post.title;
            })
            .catch(function() {
                $scope.posting.active = false;
                $scope.posting.status = 'failed';
            })
    };

    $scope.childrenDone = function(item) {
        if (!item.children) return false;
        var done = true;
        _.each(item.children, function(child) {
            if (!child.testSegment) return;
            if (child.testSegment.progress.completed < child.testSegment.progress.total) {
                done = false;
                return false;
            }
        });
        return done;
    }

    var loadAllPosts = function(certificationMap) {
        var slugs = [];
        var getSlugs = function(items) {
            _.each(items, function(item) {
                if (item.slug) slugs.push(item.slug);
                if (item.children) getSlugs(item.children);
            });
        };
        getSlugs(certificationMap);
        return dataService.contentApi.posts.browse({limit:100, filter: 'slug:['+slugs.join(',')+']'})
            .then(function(posts) {
                var itemsWithTestSegments = [];
                var getTestSegments = function(items) {
                    _.each(items, function(item) {
                        if (item.testSegment) itemsWithTestSegments.push(item);
                        if (item.children) getTestSegments(item.children);
                    });
                };
                getTestSegments(certificationMap);
                // console.log('items', certificationMap, itemsWithTestSegments);

                return $q.all(_.map(itemsWithTestSegments, function(item) {
                    return dataService.getTestSegment(item.testSegment)
                        .then(function(result) {
                            item.testSegment = result.data;
                        })
                }))
                    .then(function() { return posts });
            })
    };
}

function CertificationTestSegmentController($scope, $sce) {
    var self = this;
    $scope.testSegment = {};

    this.$onChanges = function() {
        $scope.testSegment = self.testSegment;

        if (!$scope.testSegment) return;

        _.each($scope.testSegment.questions, function(q) {
            if (q.type === 'trueFalse') {
                _.each(q.answers, function(a) {
                    if (a.isCorrect) {
                        if (a.selected) q.answerInfo = $sce.trustAsHtml('<div class="ui-success"><i class="fa fa-check"></i> Correct</div>');
                    }
                    else {
                        if (a.selected) q.answerInfo = $sce.trustAsHtml('<div class="ui-danger"><i class="fa fa-times"></i> Incorrect</div>');
                    }
                })
            }
            else if (q.type === 'singleSelect') {
                var correct = false;
                var selected = false;
                _.each(q.answers, function(a) {
                    if (a.selected) {
                        selected = true;
                        if (a.isCorrect) correct = true;
                    }
                });

                if (selected) {
                    if (correct) {
                        q.answerInfo = $sce.trustAsHtml('<div class="ui-success"><i class="fa fa-check"></i> Correct</div>');
                    }
                    else {
                        var correctAnswer = _.find(q.answers, function(a) { return a.isCorrect });
                        if (correctAnswer)
                            q.answerInfo = $sce.trustAsHtml('<div class="ui-danger"><i class="fa fa-times"></i> Incorrect - '+correctAnswer.answer+'</div>');
                    }
                }
            }
            else if (q.type === 'multiSelect') {
                var needed = 0;
                var correct = 0;
                var incorrect = 0;
                _.each(q.answers, function(a) {
                    if (a.isCorrect) {
                        needed++;
                        if (a.selected) correct++;
                    }
                    else {
                        if (a.selected) incorrect++;
                    }
                });

                if ((correct+incorrect) >= needed) {
                    if (correct === needed && incorrect <= 0) {
                        q.answerInfo = $sce.trustAsHtml('<div class="ui-success"><i class="fa fa-check"></i> Correct</div>');
                    }
                    else {
                        var correctAnswers = _.map(_.filter(q.answers, function(a) { return a.isCorrect }), function(a) { return a.answer; });
                        q.answerInfo = $sce.trustAsHtml('<div class="ui-danger"><i class="fa fa-times"></i> Incorrect - '+correctAnswers.join(' / ')+'</div>');
                    }
                }
            }
        })
    }

    $scope.toggleTrueFalse = function(q, a) {
        if (q.answerChecked) return;
        _.each(q.answers, function(x) {x.selected = false});
        a.selected = true;
        self.onAnswer();
    }
    $scope.toggleSingleSelect = function(q, a) {
        if (q.answerChecked) return;
        _.each(q.answers, function(x) {x.selected = false});
        a.selected = true;
        self.onAnswer();
    }
    $scope.toggleMultiSelect = function(q, a) {
        if (q.answerChecked) return;
        a.selected = !a.selected;
        self.onAnswer();
    }
    $scope.checkAnswers = function(testSegment) {
        _.each(testSegment.questions, function(q) {
            if (q.type === 'trueFalse') {
                _.each(q.answers, function(a) {
                    if (a.selected) {
                        if (a.isCorrect) {
                            q.answerInfo = $sce.trustAsHtml('<div class="ui-success"><i class="fa fa-check"></i> Correct</div>');
                            q.answerIsCorrect = true;
                        }
                        else {
                            q.answerInfo = $sce.trustAsHtml('<div class="ui-danger"><i class="fa fa-times"></i> Incorrect</div>');
                            q.answerIsCorrect = false;
                        }
                        q.answerChecked = true;
                        return false;
                    }
                });
            }
            else if (q.type === 'singleSelect') {
                q.answerInfo = null;

                var correct = false;
                var selected = false;
                _.each(q.answers, function(a) {
                    if (a.selected) {
                        selected = true;
                        if (a.isCorrect) correct = true;
                    }
                });
                if (selected) {
                    if (correct) {
                        q.answerInfo = $sce.trustAsHtml('<div class="ui-success"><i class="fa fa-check"></i> Correct</div>');
                        q.answerIsCorrect = true;
                    }
                    else {
                        var correctAnswer = _.find(q.answers, function(a) { return a.isCorrect });
                        if (correctAnswer)
                            q.answerInfo = $sce.trustAsHtml('<div class="ui-danger"><i class="fa fa-times"></i> Incorrect - '+correctAnswer.answer+'</div>');
                        q.answerIsCorrect = false;
                    }
                    q.answerChecked = true;
                }
            }
            else if (q.type === 'multiSelect') {
                q.answerInfo = null;

                var needed = 0;
                var correct = 0;
                var incorrect = 0;
                _.each(q.answers, function(a) {
                    if (a.isCorrect) {
                        needed++;
                        if (a.selected) correct++;
                    }
                    else {
                        if (a.selected) incorrect++;
                    }
                });
                if ((correct+incorrect) > 0) {
                    if (correct === needed && incorrect <= 0) {
                        q.answerInfo = $sce.trustAsHtml('<div class="ui-success"><i class="fa fa-check"></i> Correct</div>');
                        q.answerIsCorrect = true;
                    }
                    else {
                        var correctAnswers = _.map(_.filter(q.answers, function(a) { return a.isCorrect }), function(a) { return a.answer; });
                        q.answerInfo = $sce.trustAsHtml('<div class="ui-danger"><i class="fa fa-times"></i> Incorrect - '+correctAnswers.join(' / ')+'</div>');
                        q.answerIsCorrect = false;
                    }
                    q.answerChecked = true;
                }
            }
        });
        self.onAnswer();
    }
}

angular.module('app')
    .component('certificationIndex', {
        transclude: true,
        controller: ['$scope', '$sce', '$q', '$location', 'dataService', CertificationIndexController],
        templateUrl: '/assets/built/app/components/certification/certificationIndex.html'
    })
    .component('certificationTestSegment', {
        controller: ['$scope', '$sce', CertificationTestSegmentController],
        templateUrl: '/assets/built/app/components/certification/certificationTestSegment.html',
        bindings: {
            testSegment: '<',
            onAnswer: '<'
        }
    })
    .component('certificationForm', {
        transclude: true,
        controller: ['$scope', '$timeout', '$element', 'dataService', CertificationFormController],
        templateUrl: '/assets/built/app/components/certification/certificationForm.html'
    })
